const footerLinks = [
  {
    label: 'Chi siamo',
    url: '/casait/chi-siamo/',
    altText: 'Chi siamo',
    target: null,
    rel: '',
    cssClass: 'who',
  },
  {
    label: 'Privacy',
    url: '/casait/privacy/',
    altText: 'Privacy',
    target: null,
    rel: 'noopener noreferrer',
    cssClass: 'pri',
  },
  {
    label: 'Contattaci',
    url: '/casait/contatti/',
    altText: 'Contattaci',
    target: null,
    rel: '',
    cssClass: 'pub',
  },
  {
    label: 'Info Legali',
    url: '/casait/informazioni-legali/',
    altText: 'Info Legali',
    target: null,
    rel: '',
    cssClass: 'inf',
  },
  {
    label: 'Cookie',
    url: '/casait/cookie/',
    altText: 'Cookie',
    target: null,
    rel: '',
    cssClass: 'coo',
  },
  {
    label: 'Segnala abuso',
    url: '/casait/segnala-abuso/',
    altText: 'Segnala abuso',
    target: null,
    rel: '',
    cssClass: 'con',
  },
  {
    label: 'Ufficio Stampa',
    url: '/casait/press-room/',
    altText: 'Ufficio Stampa',
    target: null,
    rel: '',
    cssClass: 'uff',
  },
  {
    label: 'Pubblicità',
    url: '/casait/pubblicita/',
    altText: 'Pubblicità',
    target: '_blank',
    rel: 'noopener noreferrer',
    cssClass: 'admin',
  },
  {
    label: 'Gestione consenso cookie',
    url: null,
    action: (e) => {
      e.preventDefault();
      if (window.Didomi) {
        window.Didomi.preferences.show();
      }
    },
    altText: 'Gestione consenso cookie',
    target: null,
    rel: 'nofollow',
    cssClass: 'pre',
  },
  {
    label: 'Lavora con noi',
    url: '/casait/lavora-con-noi/',
    altText: 'Lavora con noi',
    target: null,
    rel: '',
    cssClass: 'job',
  },
  {
    label: '',
    cssClass: 'spa',
  },
  {
    label: 'Sicurezza',
    url: '/casait/annunci-immobiliari-sicuri/',
    altText: 'Sicurezza',
    target: null,
    rel: '',
    cssClass: 'sic',
  },
  {
    label: 'Scarica l\'app',
    url: '/casait/app-annunci-casa/',
    altText: 'Scarica l\'app',
    target: null,
    rel: '',
    cssClass: 'app',
  },
];

export default footerLinks;
